import type { IBaseProps } from '@sixui/ui';
import { forwardRef } from 'react';
import stylex from '@stylexjs/stylex';
import { Link, LinkProps as RouterLinkProps } from 'react-router-dom';

import { useOptionalAppRegion } from '~/hooks/useOptionalAppRegion';
import { getNavigationUrl } from './getNavigationUrl';

export type ILinkBehaviorProps = IBaseProps &
  Pick<RouterLinkProps, 'replace'> & {
    href: string;
    children?: React.ReactNode;
  };

export const LinkBehavior = forwardRef<HTMLAnchorElement, ILinkBehaviorProps>(
  function LinkBehavior(props, ref) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, sx, styles, visualState, ...other } = props;
    const appRegion = useOptionalAppRegion();

    // Map href (sixui) -> to (react-router)
    return (
      <Link
        ref={ref}
        to={getNavigationUrl(href, appRegion)}
        {...stylex.props(sx)}
        {...other}
      />
    );
  },
);
